import { StoreType } from '@tock/shared/utils/connect';
import { getAvailability } from 'selectors/availabilitySearchSelectors';
import { useSelector } from 'react-redux';

/**
 * makes the availability state available through a selector
 * @returns {StoreType['availability']} availability
 */
export function useSearchResults(): StoreType['availability'] {
  const availability = useSelector(getAvailability);
  return availability;
}
